import type { SessionObject, PremiumFeatures } from '@lub0v/santa-utils';

export const PREMIUM_TIERS = {
  tier_1: { ru: 'Волшебник', en: 'Wizard', actionRu: 'Стать Волшебником', actionEn: 'Become a Wizard' },
  tier_2: { ru: 'Санта-Мастер', en: 'Santa Master', actionRu: 'Стать Санта-Мастером', actionEn: 'Become a Master' },
  tier_3: { ru: 'Санта-Магистр', en: 'Santa Grandmaster', actionRu: 'Стать Санта-Магистром', actionEn: 'Become a Grandmaster' },
} as const;
export type PremiumTier = keyof typeof PREMIUM_TIERS;
export function purchasedTier(user: SessionObject | null | undefined): PremiumTier | undefined {
  const tier = user?.premium?.access.tier;
  return tier === 'full' ? 'tier_3' : tier && tier in PREMIUM_TIERS ? tier as PremiumTier : undefined;
}
export function premiumTierName(tier: PremiumTier, ru: boolean) {
  return PREMIUM_TIERS[tier][ru ? 'ru' : 'en'];
}

/** A game's effective access may come from its organizers, not the viewer. */
export function gameAccessTier(features?: PremiumFeatures): PremiumTier | undefined {
  if (!features) return undefined;
  if (features.boxDomain || features.boxMultiOrg) return 'tier_3';
  if (features.boxDraw || features.boxQuestions || features.boxActivityLog) return 'tier_2';
  if (features.boxThemes) return 'tier_1';
  return undefined;
}
